import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import NavBar from "./components/navbar/NavBar";
import Login from "./components/auth/Login";
//import "./index.css";
//import "./components/Sorteo/sorteo.css";
import SorteoView from "./components/SorteoView/SorteoView";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import GestionBingoView from "./components/gestionView/GestionBingoView";
import ManagePagoView from "./components/managePagos/ManagePagoView";

const AppContent = () => {
  const navigate = useNavigate();

  // Detectar si la página fue recargada (F5, Ctrl+R, etc)
  useEffect(() => {
    // Solo ejecutar una vez
    const hasReloaded = sessionStorage.getItem("hasReloaded");

    // performance.navigation.type === 1 significa recarga
    if (
      !hasReloaded &&
      performance &&
      performance.navigation &&
      performance.navigation.type === 1
    ) {
      // Es un refresh - cerrar sesión
      sessionStorage.setItem("hasReloaded", "true");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("userEmail");
    }
  }, []);

  return (
    <div className="App">
      <NavBar />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/gestion"
          element={
            <ProtectedRoute>
              <GestionBingoView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sorteo"
          element={
            <ProtectedRoute>
              <SorteoView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pagos"
          element={
            <ProtectedRoute>
              <ManagePagoView />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
